import { Card } from "components/ui/card";
import { Color } from "utils/theme";

interface Props {
  label: string;
  value: any;
}

export const DataStatus = ({ label, value }: Props) => {
  return (
    <Card className="px-4 py-3">
      <div className="flex space-x-8 justify-between overflow-hidden">
        <p
          className="font-medium whitespace-nowrap mb-1"
          style={{ color: Color.White }}
        >
          {label}
        </p>
        <p className="text-right" style={{ color: Color.Primary[400] }}>
          {value}
        </p>
      </div>
    </Card>
  );
};
